import React from 'react';
import { ListButton, RefreshButton } from 'react-admin';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import { Link } from 'react-router-dom';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const UserShowActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <Button
      component={Link}
      color="primary"
      to={{
        pathname: '/subscriptions/create',
        state: { record: { user_id: data ? data.id : null } },
        search: data ? `?user_id=${data.id}` : '',
      }}
    >
      Create subscription
    </Button>
    <ListButton basePath={basePath} />
    <RefreshButton />
  </CardActions>
);

export default UserShowActions;



// WEBPACK FOOTER //
// ./src/resources/users/show/UserShowActions.jsx